import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 304,
  name: 'Not Modified',
  description:
    'The resource has not been modified since the last request. The server tells the client to use its cached copy instead of downloading the resource again. This saves bandwidth and speeds up page loads.',
  causes: [
    'The client sent a conditional request with If-Modified-Since or If-None-Match headers, and the resource has not changed.',
    'Browser cache is working correctly — the ETag or Last-Modified date matches what the server has.',
    'CDN or reverse proxy validated that the cached version is still current.',
  ],
  fixes: [
    'No fix needed — 304 is a performance optimization. It means caching is working correctly and saving bandwidth.',
    'If you need to force a fresh response, clear the browser cache or add a cache-busting query parameter (e.g., ?v=2) to the URL.',
    'If the server always returns 304 even after content changes, check your ETag generation or Last-Modified header logic. Stale ETags cause users to see outdated content.',
  ],
  monitoringTip:
    'Uptrack sends fresh requests without cache headers, so your endpoints return full responses (200) rather than 304. This ensures Uptrack validates the actual content, not just the cache layer.',
}

export const Route = createFileRoute('/_site/http/304')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
